import React from 'react'
import ClassName from 'classnames'
import styles from './TourResale.module.scss'

const TourResale = ({ className = '', title = 'Tour Resale', url }) => {
  return (
    <iframe
      title={title}
      src={url}
      className={ClassName(styles.tourResale, className)}
    />
  )
}

export default React.memo(TourResale)
